import React, { Component } from 'react';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import './_styles.scss';
import { YellowButton } from '../../components/YellowButton/YellowButton';
import ConfigMenuButton from '../../components/ConfigMenuButton/ConfigMenuButton';
import { getConfigModal } from '../config/ConfigModals/configModals';

class ConfigDetails extends Component {
    constructor(props) {
        super(props);
        this.config = getConfigModal(this.props.match.params.type);
    }

    buttonsContainer = null;
    focusTimeout = null;

    componentDidMount() {
        this.setFirstButtonFocus();
    }

    componentWillUnmount() {
        if (this.focusTimeout) {
            clearTimeout(this.focusTimeout);
        }
    }

    setButtonsContainerRef = (element) => {
        this.buttonsContainer = element;
    }

    setFirstButtonFocus = () => {
        if (this.buttonsContainer) {
            this.focusTimeout = setTimeout(() => {
                const firstFocusable = this.buttonsContainer.querySelector('.focusable');
                if (firstFocusable) {
                    firstFocusable.focus();
                }
            }, 0);
        }
    }

    render() {
        const { title = '', img, buttons = [] } = this.config;
        return (
            <div className="config-modal">
                <div className='header'>
                   <div className='icon'>
                        <img src={Asset.get('logo_clarotv')}/>
                   </div>
                   <div className='back-button-container'>
                       <YellowButton label={Translator.get('top_head_option_button_back')} onClick={() => this.props.history.goBack()}/>
                   </div>
                </div>

                <div className='title'>
                    <p>{Translator.get(title)}</p>
                </div>

                <div className='content'>
                    <div className='left-column'>
                       { img && <img src={Asset.get(img)}/> }
                    </div>

                    <div className='right-column'>
                        <div className='buttons-container' ref={this.setButtonsContainerRef}>
                            {buttons.map((button) => (
                                <ConfigMenuButton key={button.id} labelKey={button.labelKey} onClick={button.onClick}/>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfigDetails;


// WEBPACK FOOTER //
// ./src/containers/ConfigDetails/ConfigDetails.jsx